import React from 'react';
import { SupplierLayout } from '../../components/SupplierLayout';
import { MOCK_PAYMENTS } from '../../lib/supplierStore';
import { Download, Filter, Search } from 'lucide-react';
export function SupplierPayments() {
  const totalSettled = MOCK_PAYMENTS.filter(p => p.status === 'Settled').reduce((acc, p) => acc + p.amount, 0);
  const totalPending = MOCK_PAYMENTS.filter(p => p.status !== 'Settled').reduce((acc, p) => acc + p.amount, 0);
  return <SupplierLayout data-id="element-3942">
      <div className="max-w-6xl mx-auto" data-id="element-3943">
        <div className="flex items-center justify-between mb-8" data-id="element-3944">
          <h1 className="text-2xl font-display font-bold text-gray-900" data-id="element-3945">
            Payments
          </h1>
          <button className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-xl text-sm font-bold text-gray-700 hover:bg-gray-50 transition-colors shadow-sm" data-id="element-3946">
            <Download className="w-4 h-4" data-id="element-3947" /> Export CSV
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8" data-id="element-3948">
          <div className="bg-white p-6 rounded-2xl border border-gray-200 shadow-sm" data-id="element-3949">
            <p className="text-sm font-bold text-gray-500 mb-2" data-id="element-3950">
              Settled (This Month)
            </p>
            <p className="text-3xl font-display font-bold text-gray-900" data-id="element-3951">
              AED {totalSettled.toLocaleString()}
            </p>
          </div>
          <div className="bg-white p-6 rounded-2xl border border-gray-200 shadow-sm" data-id="element-3952">
            <p className="text-sm font-bold text-gray-500 mb-2" data-id="element-3953">
              Pending Settlement
            </p>
            <p className="text-3xl font-display font-bold text-brand-600" data-id="element-3954">
              AED {totalPending.toLocaleString()}
            </p>
          </div>
          <div className="bg-white p-6 rounded-2xl border border-gray-200 shadow-sm" data-id="element-3955">
            <p className="text-sm font-bold text-gray-500 mb-2" data-id="element-3956">
              Lifetime Earnings
            </p>
            <p className="text-3xl font-display font-bold text-gray-900" data-id="element-3957">
              AED 142,500
            </p>
          </div>
        </div>

        <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-3958">
          <div className="p-4 border-b border-gray-100 flex flex-col sm:flex-row gap-4 justify-between items-center bg-gray-50/50" data-id="element-3959">
            <div className="relative w-full sm:w-64" data-id="element-3960">
              <Search className="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" data-id="element-3961" />
              <input type="text" placeholder="Search Job ID or Customer..." className="w-full pl-9 pr-4 py-2 bg-white border border-gray-200 rounded-xl text-sm outline-none focus:border-brand-300" data-id="element-3962" />
            </div>
            <button className="flex items-center gap-2 px-3 py-2 bg-white border border-gray-200 rounded-xl text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors w-full sm:w-auto justify-center" data-id="element-3963">
              <Filter className="w-4 h-4" data-id="element-3964" /> Filter Status
            </button>
          </div>

          <div className="overflow-x-auto" data-id="element-3965">
            <table className="w-full text-left text-sm" data-id="element-3966">
              <thead className="bg-gray-50 text-gray-500 font-bold uppercase tracking-wider text-[10px]" data-id="element-3967">
                <tr data-id="element-3968">
                  <th className="px-6 py-4" data-id="element-3969">Date</th>
                  <th className="px-6 py-4" data-id="element-3970">Job ID</th>
                  <th className="px-6 py-4" data-id="element-3971">Customer & Service</th>
                  <th className="px-6 py-4" data-id="element-3972">Amount</th>
                  <th className="px-6 py-4" data-id="element-3973">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100" data-id="element-3974">
                {MOCK_PAYMENTS.map(p => <tr key={p.id} className="hover:bg-gray-50/50 transition-colors" data-id="element-3975">
                    <td className="px-6 py-4 text-gray-600 whitespace-nowrap" data-id="element-3976">
                      {p.date}
                    </td>
                    <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap" data-id="element-3977">
                      {p.jobId}
                    </td>
                    <td className="px-6 py-4" data-id="element-3978">
                      <p className="font-bold text-gray-900" data-id="element-3979">{p.customer}</p>
                      <p className="text-xs text-gray-500" data-id="element-3980">{p.service}</p>
                    </td>
                    <td className="px-6 py-4 font-bold text-gray-900 whitespace-nowrap" data-id="element-3981">
                      AED {p.amount}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-3982">
                      <span className={`inline-flex items-center px-2.5 py-1 rounded-md text-[10px] font-bold uppercase tracking-wider ${p.status === 'Settled' ? 'bg-green-100 text-green-700' : p.status === 'Pending' ? 'bg-orange-100 text-orange-700' : 'bg-blue-100 text-blue-700'}`} data-id="element-3983">
                        {p.status}
                      </span>
                      {p.settlementDate && <p className="text-[10px] text-gray-400 mt-1" data-id="element-3984">
                          on {p.settlementDate}
                        </p>}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </SupplierLayout>;
}